import { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentJWTUser } from '@/lib/auth';

interface PublicOnlyGuardProps {
  children: ReactNode;
}

export function PublicOnlyGuard({ children }: PublicOnlyGuardProps) {
  const navigate = useNavigate();
  const hasValidSession = !!getCurrentJWTUser();

  useEffect(() => {
    if (hasValidSession) {
      navigate('/');
    }
  }, [hasValidSession, navigate]);

  return <>{children}</>;
}
